import React from 'react';

const LeadsContext = React.createContext({});
LeadsContext.displayName = 'LeadsContext';

export default LeadsContext;
